import { useMemo } from 'react';

function usePluginMap(plugins) {
  return useMemo(() => plugins.reduce((map, plugin) => {
    map.set(plugin.type, plugin);
    return map;
  }, new Map()), [plugins]);
}

export { usePluginMap };
